import { Grid, Skeleton, Typography } from '@mui/material';
import { ReactElement } from 'react';
import { ChangeHistoryColumnValue } from './ChangeHistoryColumnValue';
import { IComponentCss } from '@tap/mui-ui';
import { ChangeHistoryColumnDiffProps } from './ChangeHistoryColumnDiff';

const css: IComponentCss = {
    root: {
        wordWrap: 'break-word',
    },
    firstColumn: {
        paddingRight: '20px',
    },
    secondColumn: {
        paddingRight: '20px',
    },

}


export const SimpleColumnDiffSkeleton = () => {
    return (
        <Grid container sx={css.root}>
            <Grid item
                md={4}
                xs={12}
                sx={css.firstColumn}>
                <Typography>
                    <Skeleton />
                </Typography>
            </Grid>
            <Grid item
                md={4}
                xs={12}
                sx={css.secondColumn}>
                <Skeleton />
            </Grid>
            <Grid item
                md={4}
                xs={12}>
                <Skeleton />
            </Grid>
        </Grid>


    );
};

export const SimpleColumnDiff = ({
    title,
    oldValue,
    newValue,
    columnInfo,
    slots,
    slotProps,
}: ChangeHistoryColumnDiffProps): ReactElement => {
    return (
        <Grid container sx={css.root}>
            <Grid item
                md={4}
                xs={12}
                sx={css.firstColumn}>
                <Typography>{title}</Typography>
            </Grid>
            <Grid item
                md={4}
                xs={12}
                sx={css.secondColumn}>
                <ChangeHistoryColumnValue value={oldValue}
                    columnInfo={columnInfo}
                    slots={slots}
                    slotProps={slotProps} />
            </Grid>
            <Grid item
                md={4}
                xs={12}>
                <ChangeHistoryColumnValue value={newValue}
                    columnInfo={columnInfo}
                    slots={slots}
                    slotProps={slotProps} />
            </Grid>
        </Grid>
    );
};
